import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";
import { useGrammar } from "context/grammarContext";
import arrow from "../../assets/img/gifs/arrow_pt.gif";
import grammar from "../../assets/img/gifs/grammar_pt.gif";
import lambda from "../../assets/img/gifs/lambda-pt.gif";
import varenum from "../../assets/img/gifs/varenum_pt.gif";
import { useUser } from "context/userContext";

export default function HowToUseGrammarDialog() {
  const { setActiveDialogHowToUseGrammar, isActiveDialogHowToUseGrammar } =
    useGrammar();
  const handleClose = () => {
    setActiveDialogHowToUseGrammar(false);
  };
  const { language } = useUser();

  const texts = {
    title: {
      en: "How to Start",
      pt: "Como começar",
    },
    grammarName: {
      title: {
        en: "Naming the grammar.",
        pt: "Nomeando a gramática.",
      },
      text: {
        en: "Click on the text box at the top of the screen and type the name you want for your grammar.",
        pt: "Clique na caixa de texto no topo da tela e digite o nome que você quer para sua gramática.",
      },
    },
  };

  return (
    <div>
      <Dialog
        open={isActiveDialogHowToUseGrammar}
        onClose={handleClose}
        style={{ height: "746px" }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {texts.title[language]}
        </DialogTitle>

        <DialogContent dividers>
          <div
            style={{
              marginBottom: "20px",
              borderBottom: "1px solid #eee",
              paddingBottom: "10px",
            }}
          >
            <Typography
              variant="subtitle1"
              style={{ fontWeight: "bold", marginBottom: 5 }}
            >
              {texts.grammarName.title[language]}
            </Typography>
            <Typography variant="body2" color="textSecondary">
              {texts.grammarName.text[language]}
            </Typography>
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "15px",
            }}
          >
            <img
              src={lambda}
              alt="Lambda"
              id="infoPopup"
              style={{ maxWidth: "100%" }}
            />
            <img
              src={arrow}
              alt="Arrow"
              id="infoPopup"
              style={{ maxWidth: "100%" }}
            />
            <img
              src={varenum}
              alt="VarEnum"
              id="infoPopup"
              style={{ maxWidth: "100%" }}
            />
            <img
              src={grammar}
              alt="Grammar"
              id="infoPopup"
              style={{ maxWidth: "100%" }}
            />
          </div>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClose} color="primary" autoFocus>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
